<template>
  <div class="a-select-checkbox" ref="selectContainer">
    <div @click="toggleDropdown" class="select-box" :class="{ disabled: disabled }">
      <span>{{ selectedLabels.length ? selectedLabels.join(', ') : 'Estado de Venta' }}</span>
      <i class="arrow" :class="{ open: isOpen }"></i>
    </div>
    <div v-if="isOpen" class="dropdown">
      <label v-for="(element, index) in elements" :key="index" class="checkbox-label">
        <input
          type="checkbox"
          :value="element.id"
          v-model="selectedValues"
          @change="handleSelection(element.id)" />
        {{ element.name }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AtomSelectCheckboxPrimary',
  props: {
    elements: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: false,
      selectedValues: this.value
    }
  },
  computed: {
    selectedLabels () {
      return this.selectedValues.map(
        (val) => this.elements.find((option) => option.id === val).name
      )
    }
  },
  methods: {
    toggleDropdown () {
      if (!this.disabled) {
        this.isOpen = !this.isOpen
        if (this.isOpen) {
          document.addEventListener('click', this.handleClickOutside)
        }
      }
    },
    handleClickOutside (event) {
      if (this.$refs.selectContainer && !this.$refs.selectContainer.contains(event.target)) {
        this.isOpen = false
        document.removeEventListener('click', this.handleClickOutside)
      }
    },
    handleSelection (value) {
      if (value === '') {
        this.selectedValues = ['']
      } else {
        this.selectedValues = this.selectedValues.filter(v => v !== '')
      }
    }
  },
  watch: {
    value (newValue) {
      this.selectedValues = newValue
    },

    selectedValues (newValue) {
      this.$emit('input', newValue)
      this.$emit('onChange', newValue)
    },

    beforeDestroy () {
      document.removeEventListener('click', this.handleClickOutside)
    }
  }
}
</script>
